import { ShippingSettingsRepository } from '@lib/api/repository/shipping-settings/shipping-settings.repository';
import {
  MarketplaceSettings,
  ShippingIntegrationStatus,
  ShippingPackageSettingsInput,
  ShippingProviderService,
  ShippingServiceSetting,
} from '@lib/types';

import { Requester } from '../clients';

interface ShippingServiceSettingInputDTO {
  providerServiceId: string;
  enabled: boolean;
  displayOrder: number;
}

export default class ShippingSettingsAPI implements ShippingSettingsRepository {
  async updatePackageSettings(input: ShippingPackageSettingsInput) {
    return (
      await Requester.patch<MarketplaceSettings>(
        '/marketplace/admin/settings',
        { body: input },
      )
    ).data;
  }

  async getIntegrationStatus(signal?: AbortSignal) {
    return (
      await Requester.get<ShippingIntegrationStatus>(
        '/integrations/melhor-envio/status', { signal },
      )
    ).data;
  }

  async authorizeIntegration(signal?: AbortSignal) {
    const response = await Requester.get<{ authorizationUrl: string }>(
      '/integrations/melhor-envio/authorize', { signal },
    );

    return response.data.authorizationUrl;
  }

  async get(signal?: AbortSignal) {
    return (
      await Requester.get<MarketplaceSettings>('/marketplace/admin/settings', { signal })
    ).data;
  }

  async listAvailable(signal?: AbortSignal) {
    return (
      await Requester.get<ShippingProviderService[]>(
        '/marketplace/admin/settings/shipping-services/available', { signal },
      )
    ).data;
  }

  async replace(services: ShippingServiceSetting[]) {
    const serviceInputs: ShippingServiceSettingInputDTO[] = services.map(
      ({ providerServiceId, enabled, displayOrder }) => ({
        providerServiceId,
        enabled,
        displayOrder,
      }),
    );

    return (
      await Requester.patch<ShippingServiceSetting[]>(
        '/marketplace/admin/settings/shipping-services',
        { body: { services: serviceInputs } },
      )
    ).data;
  }
}
